import type {
  ProfileWithCredits,
  ProfileIdentifier,
} from './profiles-credits-summary.types'
import type { ProfileProduct, SingleUseCredit } from '~/types'

// Note: omits profiles with no credits
export function nestProfileCredits({
  profiles,
  profileProducts,
  credits,
}: {
  profiles: ProfileIdentifier[]
  profileProducts: ProfileProduct[]
  credits: SingleUseCredit[]
}): ProfileWithCredits[] {
  const nestedProfileData = profiles.map((profile) => {
    const profileProductIds = profileProducts
      .filter(({ profileId }) => profileId === profile.id)
      .map((profileProduct) => profileProduct.id)

    const creditsForProfile = credits
      .filter((credit) => profileProductIds.includes(credit.profileProductId))
      .map((credit) => {
        return {
          ...credit,
          profileProduct: profileProducts.find(
            ({ id }) => id === credit.profileProductId,
          ),
        }
      })
      .filter((credit) => credit.profileProduct !== undefined)

    return { ...profile, credits: creditsForProfile }
  })

  return nestedProfileData.filter((profile) => profile.credits.length > 0)
}
